import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCheck, faShare } from '@fortawesome/pro-solid-svg-icons';
import TaskIcon from 'components/tasks/task_icon';

class TasksCompleted extends React.Component {
  static propTypes = {
    editingTask: PropTypes.object.isRequired,
    followUpTask: PropTypes.object.isRequired,
    showFollowUp: PropTypes.bool.isRequired
  }

  taskType(type) {
    switch (type) {
    case 1:
      return "call";
    case 2:
      return "email";
    default:
      return "other";
    }
  }

  renderTaskIcon(iconClass, icon) {
    return (
      <div className="task-icon">
        <span className="fa-layers fa-fw">
          <FontAwesomeIcon className={iconClass} icon={faCircle} size="2x"/>
          <FontAwesomeIcon
            icon={icon}
            size="2x"
            transform="shrink-8"
          />
        </span>
      </div>
    );
  }

  render() {
    const { editingTask, followUpTask, showFollowUp } = this.props;

    return (
      <div className="bottom-buffer-xs">
        <div className="completed-task-box bottom-buffer-sm">
          {this.renderTaskIcon("completed-circle", faCheck)}
          <div className="completed-text left-buffer-md"> Task Completed </div>
        </div>
        <div className="activity-block bottom-buffer-sm">
          <div className="completed-activity-container bottom-buffer-xs">
            <div className="pull-left completed-task-title">
              {editingTask.title}
            </div>
          </div>
        </div>
        {showFollowUp &&
          <React.Fragment>
            <div className="followup-task-box bottom-buffer-sm">
              {this.renderTaskIcon("followup-circle", faShare)}
              <div className="followup-text left-buffer-md"> Follow-up Created </div>
            </div>
            <div className="activity-block bottom-buffer-sm">
              <div className="activity-container bottom-buffer-xs">
                <div className="pull-left task-title">
                  {followUpTask.title}
                </div>
                <div className="pull-right task-icon">
                  <TaskIcon size="xs" type={this.taskType(followUpTask.taskType)}/>
                </div>
              </div>
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
}

export default TasksCompleted;
